// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {

  production: 'false',
  localEnviornment: 'true',
  uploadFileSize: 5242880,
  minorRmaMaxLimit: 99,
  edmUploadFileSize: 10485760,
  logLevel: 'TRACE',  // TRACE, DEBUG ,INFO,WARN,ERROR,FATAL,OFF
  fclURL: 'https://apidrt.idev.fedex.com',
  fclClientId: 'l7xx011238806510402296008b8ca504b7af',
  fclSecret: 'e2b11d1f622d4a85b2f88d3beebd8557',
  fclGrantType: 'client_credentials',
  fclScope: 'oob',
  oktaURL: 'http://localhost:4200',
  oktaIssuer:  'https://purpleid-stage.oktapreview.com/oauth2/aus1c2ymhu6qoMpfh0h8',
  oktaClientId: '0oarfhaewna0dX4tI0h7',
  oktaTempIssuer: 'https://purpleid-partners-stage.oktapreview.com/',
  oktaTempClientId: '0oaynlydc2eTebezA0h7',
  oktaScopes: ['openid', 'profile', 'email'],
  // apiGatewayURL: ' https://api-gwl1.services.logistics.fedex.com',
  apiAddressValidationURL: 'https://api-gwl1.supplychain.logistics.fedex.com/service/address',
  apiGatewayURL: 'https://api-gwl1.services.logistics.fedex.com',
  apiRefCodesURL: 'https://api-gwl1.services.logistics.fedex.com',
  apiGatewayClientId: '5ddc2c9e-9755-4949-b38b-cbd9858a2694',
  apiGatewaySecret: 'ff142885-08dc-4d07-8b15-e99d35b5f107',
  apiGatewayGrantType: 'client_credentials',
  apiGatewayScope: 'PP_Portal_ReadWrite',
  apiLocationURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/locations',
  apiLocationSlottingUrl: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/locationsforslotting',
  apiLocationLookUpURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/locations',
  apiInventoryURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/inventory',
  apiInventoryLocksURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/inventorylocks',
   //apiUserURL: 'http://localhost:8091/userservices/api/v1',
  apiUserURL: 'https://api-gwl1.supplychain.logistics.fedex.com/userservices/api/v1',
  apiUsersURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/users',
  apiItemURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/items',
  apiOpsItemURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/items/flare',
  apiASNURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/inboundshipment',
  apiGetASNURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/inboundshipments',
  apiOrderURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/orders',
  //apiOrderAesURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/orders/aes',
  apiBulkURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/bulkUpload',
  apiLookupURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/lookups',
  // apigetCartURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/carts',
  apiCartURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/carts',
  apiValidateItem: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/validateItems',
  apiFacilityURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/facility',

  apiLookupNameValueURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/lookupnamevalue',
  apiCustomerURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/customers',
  apiAsnVerifyUrl: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/inboundshipment/verify',
  apiAsnSummaryUrl: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/inboundshipment/asnSummary',
  apiAsnReceivingUrl: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/receiving/lpn',
  apiReceivingUrl: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/receiving',
  apiVendorURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/vendors',
  apiBussServAPPID: 'APP3536781',
  apiCriteriaSvc: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/criteria',
  apiTaskURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/task',
  apiTaskDetailsURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/taskdetails',
  apiTaskGroupURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/taskgroups',
  apiZoneGroupURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/locations/travelZoneGroups',
  apiCycleCountURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/cyclecount',
  apiCycleCountDefinitionURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/cyclecountdefinition',
  apiValueAddedServiceURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/valueaddedservice',
  apiCriteriaTrigger: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/tasks',
  apiWaveURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/wave',
  apiWaveDetailsURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/wavedetails',
  // apiLocationURL: 'http://localhost:8098/api/v1/locations',
  // apiLocationSlottingUrl: 'api/v1/locationsforslotting',
  // apiLocationLookUpURL: 'http://localhost:8110/api/v1/locations',
  // apiInventoryURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/inventory',
  // apiInventoryLocksURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/inventorylocks',
  //  //apiUserURL: 'http://localhost:8091/userservices/api/v1',
  // apiUserURL: 'https://api-gwl1.supplychain.logistics.fedex.com/userservices/api/v1',  
  // apiUsersURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/users',
  // apiItemURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/items',
  // apiOpsItemURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/items/flare',
  // apiASNURL: 'https://api-gwl1.supplychain.logistics.fedex.com/api/v1/inboundshipment',
  // apiGetASNURL: 'https://api-gwl1.supplychain.logistics.fedex.com/api/v1/inboundshipments',
  // apiOrderURL: 'http://api-int-l1-fsc-pp-orderservice.logistics.fedex.com:8082/api/v1/orders',
  // apiBulkURL: 'api/v1/bulkUpload',
  // apiLookupURL: 'http://api-int-l1-fsc-pp-lookupservice.logistics.fedex.com:8086/api/v1/lookups',
  // apigetCartURL: 'api/v1/carts',
  // apiCartURL: 'api/v1/carts',
  // apiValidateItem: 'http://api-int-l1-fsc-purple-itemservice.logistics.fedex.com:8085/api/v1/validateItems',
  //   apiFacilityURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/facility',

  // apiLookupNameValueURL: 'http://api-int-l1-fsc-pp-lookupservice.logistics.fedex.com:8086/api/v1/lookupnamevalue',
  // apiCustomerURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/customers',
  // apiAsnVerifyUrl: 'https://api-gwl1.supplychain.logistics.fedex.com/api/v1/inboundshipment/verify',
  // apiAsnSummaryUrl: 'http://localhost:8084/api/v1/inboundshipment/asnSummary',
  // apiAsnReceivingUrl: 'http://localhost:8115/api/v1/receiving/lpn',
  // apiReceivingUrl: 'http://localhost:8115/api/v1/receiving',
  // apiVendorURL: 'http://localhost:8092/api/v1/vendors',
  // apiBussServAPPID: 'APP3536781',
  // apiCriteriaSvc: 'v1/criteria/',
  // apiTaskURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/task',
  // apiTaskDetailsURL: 'v1/taskdetails',
  // apiTaskGroupURL: 'v1/taskgroups',
  // apiZoneGroupURL: 'api/v1/locations/travelZoneGroups',
  // apiCycleCountURL: 'v1/cyclecount',
  // apiCycleCountDefinitionURL: 'v1/cyclecountdefinition',
  // apiValueAddedServiceURL: 'v1/valueaddedservice',
  // apiWaveURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/wave',
  // apiWaveDetailsURL: 'http://localhost:8317/v1/wavedetails',
  apiWaveLogsURL: 'http://api-int-l1-fsc-pp-orderservice.logistics.fedex.com:8082/api/v1/orders/waveLogs',
  apiReplenishmentURL: 'http://api-int-l1-fsc-purple-itemservice.logistics.fedex.com:8085/v1/items/replenishment',
  apiCartonTypeURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/cartontypes',
  apiCCApproveRejectURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/cyclecountapprovereject',
  pattern: '^FSCPortal?(.+?)_Admin.*',
  yardAdminRolePattern: '^YARD?(.+?).*',
  superAdminRoleName: 'FSCPortal_Admin',
  apiCartonURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/cartontypes',
  apiPrinterUrl: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/printerconfig',
  apiWaveTaskConfigURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/taskconfig',
  apiPackServiceURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/pack',
  apiPackNewServiceUrl: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/pack',
  apiPickPackServiceURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/pickAndPack',
  apiPackItemUpdateURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/packqtyconfirm',
  apiDocumentsURL: 'https://api-gwl1.supplychain.logistics.fedex.com/service/documents',
  apiInventoryMasterURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/inventorymaster',
  apiLTLShipmentURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/shipments/flare',
  apiOrderShipmentURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/orders',
  apiLookupsURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/lookupvalues',
  // apiWaveTaskConfigURL: 'v1/taskconfig',
  // apiPackServiceURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/pack',
  // apiPickPackServiceURL: 'v1/pickAndPack',
  // apiPackItemUpdateURL: 'v1/packqtyconfirm',
  // apiDocumentsURL: 'service/documents',
  // apiInventoryMasterURL: 'api/v1/inventorymaster',
  // apiLTLShipmentURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/shipments/flare',
  // apiOrderShipmentURL: 'http://api-int-l1-fsc-pp-orderservice.logistics.fedex.com:8082/api/v1/orders',
  // apiLookupsURL: 'api/v1/lookupvalues',
  apiCutOffURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/shipments/cutoffs',
  apiShipmentURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/shipments',
  apiLotMasterURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/lotnumbers',
  apiContainerURL : 'https://api-gwl1.supplychain.logistics.fedex.com/v1/containers',
  apiSaveAuthJsonURL : 'service/utility',
  apiInvoicingURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/invoice-process',
  apiInvoicingConfigURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/invoice-config',
  apiInvMovementURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/inv-movement',
  apiUserActivityURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/activity',
  apiUserActivityTrackerURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/activity-tracker',
  // For reporting
  spotFileURL: 'https://spfr-analytics-l2.logistics.fedex.com/spotfire/wp/OpenAnalysis?file=/',
  pickListReportRoute: '/powerbi/groups/5d0465b2-5a34-4bec-b582-64c60068ffcd/rdlreports/26e753fa-58a0-4241-a832-c69e4249b4c3',

  // apiInvoicingURL: 'http://localhost:8337/api/v1/invoice-process',
  // apiInvoicingConfigURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/invoice-config',
  // apiInvMovementURL: 'http://api-int-l1-fsc-pp-lookupservice.logistics.fedex.com:8086/api/v1/inv-movement',
  // apiUserActivityURL: 'http://localhost:8343/v1/activity',
  // // For reporting
  // spotFileURL: 'https://spfr-analytics-l2.logistics.fedex.com/spotfire/wp/OpenAnalysis?file=/',
  // pickListReportURL: 'FSC/ECOMMERCE/FLARE/Operational/Reports/PICKLIST%20REPORT&configurationBlock=BL=',
 
  // For RLOG
  apiRlogBussServAPPID: 'APP3536966',
  apiRlogVendorURL: 'http://localhost:8092/rlog/api/v1/vendors',
  apiRlogLocationCategoriesURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/locationcategories',
  apiRlogAsnsURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/asns',
  apiRlogGroupMatrixURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/groupmatrix',
  apiRlogAsnItemsURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/asnitems',
  apiRlogSourceURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/source',
  apiRlogGroupDefsURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/groupdefs',
  apiRlogRefCodesURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/refcodes',
  apiRlogReturnTypesURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/returntype',
  apiRlogDepartmentsURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/departments',
  apiRlogDepartmentclassesURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/departmentclasses',
  apiRlogLocationsURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/location',
  apiRlogItemsURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/v1/items',
  apiRlogXRefsURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/xrefs',
  apiRlogPreapprovedItemsURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/preapprovedItems',
  apiRlogCategoryURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/category',
  apiRlogClusterSequenceURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/clustersequence',
  apiRlogWarehousesURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/warehouses',
  apiRlogLocCapacityURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/loccapacity',
  apiRlogSalvageDealersURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/salvagedealers',
  apiRlogCloseSBNumURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/closesbnum',
  apiRlogCarrierURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/carriers',
  apiRlogScreenConfigsURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/screen',
  apiRlogScansURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/scans',
  apiRlogRewarehousemovesURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/rewarehousemoves',
  apiRlogPrepSearchCriteriaURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/prepshipsearchcriteria',
  apiRlogHashdefsURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/hashdefs',
  apiRlogContainerTypesURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/containertypes',
  apiRlogOutboundWarehousesURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/obwarehouses',
  apiRlogPutawayURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/putaway',
  apiRlogReturnPointsURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/returnpoints',
  apiRlogRewarehouseURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/rewarehouse',
  apiRlogPrepShipmentURL: 'http://localhost:8109/rlog/api/v1/prepshipment',
  apiRlogSlotbyURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/slotBy',
  apiRlogPickingURL: 'http://localhost:8110/rlog/api/v1/picking',
  apiRlogEsiURL: 'http://localhost:8112/rlog/api/v1/esi',
  apiRlogRaEntryURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/raentry',
  apiRlogShipURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/ship',
  apiRlogReprintLabelURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/transaction/labels',
  apiRlogMobilityDekitActivityURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/dekit',
  apiRlogSlpLabelModelURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/mobility/slplblcfg',
  apiRlogModifyShipmentURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/modifyShipment',
  apiRlogReturnsToteSlpLabelURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/mobility/returnstoteslplblcfg',
  apiRlogSwapSerialBlURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/swapserial',
  apiRlogInquiryURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/inquiry',
  apiRlogCpiConfigURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/cpi',
  apiContainerLocksListURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/inventoryLocksList',
  apiInventoryAllocationListURL:'http://api-int-l1-fsc-pp-orderservice.logistics.fedex.com:8082/api/v1/orders/invConfigDetails',
  apiInventoryAllocationURL:'http://api-int-l1-fsc-pp-orderservice.logistics.fedex.com:8082/api/v1/orders/invconfig',
  apiRlogPrescanAsnsURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/prescan',
  apiRlogInvStatusChangeURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/invstatus',
  apiAppointmentURL:'https://api-gwl1.supplychain.logistics.fedex.com/v1/appointment',
  apiUfixURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/ufix',
  // apiContainerLocksListURL: 'api/v1/inventoryLocksList',
  // apiInventoryAllocationListURL:'http://api-int-l1-fsc-pp-orderservice.logistics.fedex.com:8082/api/v1/orders/invConfigDetails',
  // apiInventoryAllocationURL:'http://api-int-l1-fsc-pp-orderservice.logistics.fedex.com:8082/api/v1/orders/invconfig',
  // apiRlogPrescanAsnsURL: 'api/v1/prescan',
  // apiRlogInvStatusChangeURL: 'rlog/api/v1/invstatus',
  // apiAppointmentURL:'api/v1/appointment',
  // apiUfixURL: 'v1/ufix',
  uiFCLURL: 'https://wwwdrt.idev.fedex.com/',
  apiRlogRaRURL: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/rarequestentry',
  raReportURL:'FSC/ECOMMERCE/FLARE/Standard_Reports/Reports/RA_Request_Report&configurationBlock=BL%20%3D%20%27',
  fclUserInfoClientId:'l7xx7ce0f642b7dd4d0ba754e885f85feec1',
  fclUserInfoSecret:'88e897d768a24c19a6bc13f73e64ae25',
  apiPowerBiEmbedURL : 'https://api-gwl1.supplychain.logistics.fedex.com/userservices/api/v1/getEmbedInfo',
  apiPowerBiPicklistEmbedURL : 'https://api-gwl1.supplychain.logistics.fedex.com/userservices/api/v1/getPicklistEmbedInfo',
  apiPhysicalInventoryURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/physicalinventory',

  apiProcessURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/processConfig',
  apiInventoryInformation: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/inventoryforitemwithloc',
  apiASNItemLineURL: 'api/v1',
  //apiWorkflowURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/processConfig',
  apiYardURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/yard',
  apiActivityTrackingURL:"api/v1/",
  apiTriageURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/triageConfig',
  apiCartonHandler: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/cartonhandler',
  apiTriageInquiryURL:'https://api-gwl1.supplychain.logistics.fedex.com/v1/triageInquiry',
  apiAQLMasterURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/std-inbound',
  apiInboundQaAuditURL: 'http://localhost:8352/v1/qualityaudit/inboundqaconfig',
  apiInboundQaManagementURL: 'http://localhost:8352/v1/qualityaudit/inboundqaconfig',
  apiInboundQaURL:'https://api-gwl1.supplychain.logistics.fedex.com/v1/qualityaudit',
  // apiItemsByCustidBuidFcyidAndVendorid:"https://api-gwl1.supplychain.logistics.fedex.com/v1/items/getitemsbycustidbuidfcyidandvendorid",
  apiHouseKeepingURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/hk',
  //apiASNItemLineURL: 'api/v1',
  apiRepairURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/repair',
  //apiQualityAudit: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/qualityaudit/outboundqaconfig',
  apiClearLocation: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/clearlocation',
  apiBlackList: 'https://api-gwl1.supplychain.logistics.fedex.com/rlog/api/v1/blacklist',
  apiGroupConfig: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/config',
  apiJobSchedule: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/schedule',
  apiLookupNameValueURL2: 'https://api-gwl1.supplychain.logistics.fedex.com/v2/lookupnamevalue',
  apiLookupURL2: 'https://api-gwl1.supplychain.logistics.fedex.com/v2/lookups',
  apiLookupNameValuePortalURL: 'https://api-gwl1.supplychain.logistics.fedex.com/v2/lookupnamevalueForPortal',
  apiBatchDummy: 'https://api-gwl1.supplychain.logistics.fedex.com/v1/batch/execute/dummy'
};
